"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodeSystem = exports.ValueSet = exports.Concept = exports.Code = void 0;
var util_1 = require("../util/util");
var Code = /** @class */ (function () {
    function Code(code, system, version, display) {
        this.code = code;
        this.system = system;
        this.version = version;
        this.display = display;
    }
    Object.defineProperty(Code.prototype, "isCode", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Code.prototype.hasMatch = function (code) {
        if (typeof code === 'string') {
            // the specific behavior for this is not in the specification. Matching codesystem behavior.
            return code === this.code;
        }
        else {
            return codesInList(toCodeList(code), [this]);
        }
    };
    return Code;
}());
exports.Code = Code;
var Concept = /** @class */ (function () {
    function Concept(codes, display) {
        this.codes = codes;
        this.display = display;
        this.codes || (this.codes = []);
    }
    Object.defineProperty(Concept.prototype, "isConcept", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Concept.prototype.hasMatch = function (code) {
        return codesInList(toCodeList(code), this.codes);
    };
    return Concept;
}());
exports.Concept = Concept;
var ValueSet = /** @class */ (function () {
    function ValueSet(oid, version, codes) {
        if (codes === void 0) { codes = []; }
        this.oid = oid;
        this.version = version;
        this.codes = codes;
        this.codes || (this.codes = []);
    }
    Object.defineProperty(ValueSet.prototype, "isValueSet", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    ValueSet.prototype.hasMatch = function (code) {
        var codesList = toCodeList(code);
        // InValueSet String Overload
        if (codesList.length === 1 && typeof codesList[0] === 'string') {
            var matchFound = false;
            var multipleCodeSystemsExist = false;
            for (var _i = 0, _a = this.codes; _i < _a.length; _i++) {
                var codeItem = _a[_i];
                // Confirm all code systems match
                if (codeItem.system !== this.codes[0].system) {
                    multipleCodeSystemsExist = true;
                }
                if (codeItem.code === codesList[0]) {
                    matchFound = true;
                }
                if (multipleCodeSystemsExist && matchFound) {
                    throw new Error('In (valueset) is ambiguous -- multiple codes with multiple code systems exist in value set.');
                }
            }
            return matchFound;
        }
        else {
            return codesInList(codesList, this.codes);
        }
    };
    return ValueSet;
}());
exports.ValueSet = ValueSet;
function toCodeList(c) {
    if (c == null) {
        return [];
    }
    else if ((0, util_1.typeIsArray)(c)) {
        var list = [];
        for (var _i = 0, c_1 = c; _i < c_1.length; _i++) {
            var c2 = c_1[_i];
            list = list.concat(toCodeList(c2));
        }
        return list;
    }
    else if ((0, util_1.typeIsArray)(c.codes)) {
        return c.codes;
    }
    else {
        return [c];
    }
}
function codesInList(cl1, cl2) {
    // test each code in c1 against each code in c2 looking for a match
    return cl1.some(function (c1) {
        return cl2.some(function (c2) {
            // only the left argument (cl1) can contain strings. cl2 will only contain codes.
            if (typeof c1 === 'string') {
                // for "string in codesystem" this should compare the string to
                // the code's "code" field according to the specification.
                return c1 === c2.code;
            }
            else {
                return codesMatch(c1, c2);
            }
        });
    });
}
function codesMatch(code1, code2) {
    return code1.code === code2.code && code1.system === code2.system;
}
var CodeSystem = /** @class */ (function () {
    function CodeSystem(id, version) {
        this.id = id;
        this.version = version;
    }
    return CodeSystem;
}());
exports.CodeSystem = CodeSystem;
//# sourceMappingURL=clinical.js.map